<template>
  <div><img :src="f.imgsrc2"/></div>
</template>

<script>
export default {

  props: ['content'],
  computed: {
    f () {
      return {
        imgsrc2: require('../assets/' + this.content)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
div{
  width: 100%;
}
img
{
// float: left;
width: 40%;
margin-left: 10%;
display: table-cell; /*主要是这个属性*/
vertical-align: middle;
text-align: center;
}
</style>
